import React, { Component } from 'react';
import {
  Header,
  Loader,
  Button,
  Label,
  Grid,
  Icon,
  Responsive
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';

class ControlResult extends Component {
  state = {
    loading: true
  };
  componentDidMount() {
    this.fetchId(this.props.match.params.id);
  }
  fetchId = id => {
    fetch('https://paraphe.online/api/controle', {
      // fetch('http://192.168.0.150/api/controle', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id })
    })
      .then(res => {
        console.log(res.status);
        if (res.status === 429) {
          console.log('429 code error too many request');
          throw new Error(
            'Vous avez effectué trop de requêtes, veuillez attendre quelques secondes avant de recommencer'
          );
        }
        return res.json();
      })
      .then(data => {
        if (!data) {
          return this.setState({
            error: 'Aucune donnée disponible',
            loading: false
          });
        }
        if (data.error) {
          return this.setState({ error: data.error, loading: false });
        }
        return this.setState({ data, loading: false });
      })
      .catch(err => {
        this.setState({ error: err.message, loading: false });
      });
  };
  render() {
    if (this.state.loading) {
      return <Loader />;
    }
    if (this.state.error) {
      return (
        <Grid
          style={{ height: '100%', width: '100%', margin: 'auto' }}
          textAlign="center"
          stackable
        >
          <Grid.Row>
            <Grid.Column width={3} style={{ margin: 'auto' }}>
              <Icon color="red" size="massive" name="times circle" />
            </Grid.Column>
            <Grid.Column width={13} style={{ margin: 'auto' }}>
              <Header
                as="h1"
                style={{
                  color: 'red'
                }}
              >
                {this.state.error}
              </Header>
              <Button secondary as={Link} to={'/controle'}>
                {' '}
                Retour{' '}
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      );
    }
    return (
      <Grid
        style={{ height: '100%', width: '100%', margin: 'auto' }}
        textAlign="center"
        stackable
      >
        <Grid.Row>
          <Grid.Column width={3} style={{ margin: 'auto' }}>
            <Icon color="green" size="massive" name="check circle" />
          </Grid.Column>
          <Grid.Column width={13} style={{ margin: 'auto' }}>
            <Header
              as="h1"
              style={{
                color: 'black'
              }}
            >
              Nom du document :{' '}
              <Label color="blue" horizontal size="big">
                {this.state.data.nom}
              </Label>{' '}
            </Header>
            <hr />
            {this.state.data.etat === 'Signed' ? (
              <div>
                <Responsive maxWidth={768}>
                  <Grid stackable centered style={{ margin: 'auto' }}>
                    <Grid.Row centered>
                      <Grid.Column width={16} style={{ textAlign: 'center' }}>
                        <span style={{ fontWeight: 'bold' }}>Signé le : </span>
                      </Grid.Column>
                      <Grid.Column width={16} style={{ textAlign: 'center' }}>
                        <Label color="white" horizontal size="big">
                          {new Date(this.state.data.date).toLocaleString()}
                        </Label>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={16} style={{ textAlign: 'center' }}>
                        <span
                          style={{
                            fontWeight: 'bold',
                            verticalAlign: 'middle'
                          }}
                        >
                          par :{' '}
                        </span>
                      </Grid.Column>
                      <Grid.Column width={16} style={{ textAlign: 'center' }}>
                        <Label color="white" horizontal size="big">
                          {this.state.data.signataire}
                        </Label>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Responsive>
                <Responsive minWidth={769}>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={7} style={{ textAlign: 'right' }}>
                        <span
                          style={{
                            fontWeight: 'bold',
                            verticalAlign: 'middle'
                          }}
                        >
                          Signé le :{' '}
                        </span>
                      </Grid.Column>
                      <Grid.Column width={9} style={{ textAlign: 'left' }}>
                        <Label color="white" horizontal size="big">
                          {new Date(this.state.data.date).toLocaleString()}
                        </Label>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={7} style={{ textAlign: 'right' }}>
                        <span
                          style={{
                            fontWeight: 'bold',
                            verticalAlign: 'middle'
                          }}
                        >
                          par :{' '}
                        </span>
                      </Grid.Column>
                      <Grid.Column width={9} style={{ textAlign: 'left' }}>
                        <Label color="white" horizontal size="big">
                          {this.state.data.signataire}
                        </Label>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Responsive>
              </div>
            ) : (
              <span style={{ fontWeight: 'bold' }}>
                Le document n'est pas signé
                <br />
              </span>
            )}
            <Button
              style={{ marginTop: '20px' }}
              as={Link}
              to={'/controle'}
              secondary
            >
              {' '}
              Retour{' '}
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default ControlResult;



// WEBPACK FOOTER //
// ./src/Control/ControlResult.js